import React from 'react';
import './AIPopup.css';

function getRandomNumber(min, max) {
  const randomFraction = Math.random();

  const randomNumberInRange = min + (randomFraction * (max - min));


  const finalResult = Math.floor(randomNumberInRange);

  return finalResult;
}

const randomNum = getRandomNumber(1000, 2000);

function AIPopup({ isOpen, onClose }) {
  return (
    isOpen && (
      <div className="popup">
        <div className="popup-content">
          <span style={{fontSize:"45px"}} className="close-button" onClick={onClose}>&times;</span>
          <h2>AI Predicted Rate</h2>
          <p>The AI predicted rate for your crop according to your plantation details and based on the data is Rs.{randomNum}</p>
          {/* <button className="close-button" onClick={onClose}>Close</button> */}
        </div>
      </div>
    )
  );
}

export default AIPopup;
